import { CommandBarButton, DefaultButton, IButtonProps } from '@fluentui/react'
import NewChat from '../../assets/NewChat.svg'

import styles from './Button.module.css'

interface ButtonProps extends IButtonProps {
  onClick: () => void
}

export const DeleteButton: React.FC<ButtonProps> = ({ onClick }) => {

    return (
      <CommandBarButton
        className={styles.newChatButtonRoot}
        iconProps={{
          imageProps: {
            src: NewChat,
            alt: 'New Chat Icon',
            style: { width: 16, height: 16 },
          },
        }}
        style={{ height: '30px', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)'}}
        text="New Chat"
        onClick={onClick}
      />
    );
  };
export const HistoryButton: React.FC<ButtonProps> = ({ onClick, text }) => {
  return (
    <DefaultButton
      className={styles.historyButtonRoot}
      text={text}
      iconProps={{ iconName: 'History' }}
      onClick={onClick}
    />
  )
}
